module.exports = __webpack_public_path__ + "static/media/logo.eec79b81.png";